export const RESTRICTIONS_GET_ALL = 'RESTRICTIONS_GET_ALL'
export const NOTIFICATIONS_GET_ALL = "NOTIFICATIONS_GET_ALL"
export const SET_SELECTED_NOTIFICATION_ADMIN = 'SET_SELECTED_NOTIFICATION_ADMIN'
export const SET_SELECTED_NOTIFICATION = 'SET_SELECTED_NOTIFICATION'
export const SET_ACKKNOWLEDGE = 'SET_ACKKNOWLEDGE'
export const SAVE_NOTIFICATION = 'SAVE_NOTIFICATION'




// WEBPACK FOOTER //
// ./src/store/modules/notifications/mutation-types.js